const r = {
  Complete: "COMPLETE",
  Incomplete: "INCOMPLETE"
};
function e(t) {
  return n(t);
}
function n(t, o) {
  return t;
}
function s(t) {
  return t;
}
export {
  r as TaskStatus,
  e as TaskStatusFromJSON,
  n as TaskStatusFromJSONTyped,
  s as TaskStatusToJSON
};
//# sourceMappingURL=TaskStatus.js.map
